import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';
import { FiArrowLeftCircle, FiArrowRightCircle, FiEdit, FiTrash2 } from 'react-icons/fi';
import { AiFillLike } from 'react-icons/ai';
import { FaRegCommentAlt } from 'react-icons/fa';
import './styles.css';
import avatar from '../../assests/avatar.png';
import { Link, useHistory } from 'react-router-dom';


import FeedLayout from '../Includes/FeedLayout';
import ProfileChips from '../Includes/ProfileChips';
import api from '../../services/api';
import perfil from '../../assests/perfil.jpg';
import { calculaTempo } from '../../global';
import './styles.css';


export default function Meusanuncios() {
  const { t } = useTranslation();
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const [page, setPage] = useState(1);
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const ID = sessionStorage.getItem('id');
  
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState(0);
  const history = useHistory();

  function proxima() {
    setPage(page + 1);
  }
  function anterior() {
    if (page > 1) {
      setPage(page - 1);
    }
  }

  function Navegacao(props) {
    if (props.qtde >= 10) {
      return (
        <section className="paginacao">
          <div className="anterior">
            <span onClick={anterior}><FiArrowLeftCircle />{t('pages.myAnnouncements.previous')}</span>
          </div>
          <div className="proxima">
            <span onClick={proxima}>{t('pages.myAnnouncements.next')}<FiArrowRightCircle /></span>
          </div>
        </section>
      )
    } else {
      return <p></p>
    }
  }

  useEffect(() => {
    api.get(`/v6/classifieds?by_user=${sessionStorage.getItem('id')}`, {
    //api.get(`/v6/classifieds?by_user=${ID}`, {
      //api.get(`/v6/classifieds?by_user=60`, {
      headers: {
        'USER_EMAIL': sessionStorage.getItem('email'),
        'USER_TOKEN': sessionStorage.getItem('token'),
      }
    }).then(response => {
      setPosts(response.data);
      setStatus(Math.random());
    })
  }, [])

    async function excluirAnuncio(id) {
      var excl = window.confirm(t('pages.myAnnouncements.alert.confirmDelete'));
      if (!excl) {
        return false;
      }
      var axios = require('axios');
      var FormData = require('form-data');
      var data = new FormData();

      var config = {
        method: 'delete',
        url: BASE_URL + `/v6/classifieds/${id}`,
        headers: {
          'USER_EMAIL': USER_EMAIL,
          'USER_TOKEN': USER_TOKEN,
        },
        data: data
      };
      await axios(config)
        .then(function (response) {
          setTimeout(function () {
            //history.push('/meus-anuncios');
            history.go(0);
            //setStatus(Math.random());
          }, 2000);
        })
        .catch(function (error) {
        });
    }
  function alterarAnuncio(postId) {
    history.push(`/meus-anuncios/alterar/${postId}`)
  }

  function mostrarEditar(post) {
    if (post.status === 'pending') {
      // if (negoc.reviwer !== null) {
      // if (parseInt(post.user.id) !== parseInt(sessionStorage.getItem('id'))) {

      return (
        <div className="edit"><Link to="#" onClick={() => alterarAnuncio(post.id)}>
          <FiEdit />{t('pages.myAnnouncements.edit')}</Link>
          <Link className="icoExcluir" to="#" onClick={() => excluirAnuncio(post.id)}>
            <FiTrash2 className="icoExcluir" />{t('pages.myAnnouncements.delete')}
            </Link>
        </div>
      )
      // }
      // }
    }
  }
  return (
    <FeedLayout active="profile">
    <div className="meusanuncios-container">
      <div className="feed-top">{t('pages.myAnnouncements.title')}</div>
      <ProfileChips active="ads" />
      <Navegacao qtde={posts.length} />
      <section className="body">
        <ul>
          {
            posts.map(post => (
              <li key={post.id}>
                {mostrarEditar(post)}
                <p className="nomeProf"><img className="imgProf" src={post.user_info.avatar.medium === null ? avatar : post.user_info.avatar.medium} alt="Perfil" /><span className="nome">{post.user_info.name}</span><span className="tempo">  -  {calculaTempo(post.created_at)}</span></p>
                <p className="tags">
                  <span>#{post.category}</span>
                </p>
                <p className="title">{post.title}</p>
                <p className="value">{Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(post.value)}</p>

                <p className="img">
                  <img className="img_url" src={post.image_url} alt="" />
                </p>
                <p className="cidade">{post.city_info.name}/{post.state_info.acronym}</p>
                <p className="description">{post.description}</p>
                <p className="observation">{post.observation}</p>
                <p className="lermais">
                  <Link
                    to={'/meus-anuncios/detalhe/' + post.id}
                    onClick={() => sessionStorage.setItem('adFrom', 'ads')}
                  >
                    {t('pages.myAnnouncements.more')}
                  </Link>
                </p>
                {/* <p className="icons"><AiFillLike size={18} color="#DAD9E2" /><span className="like">{post.ups_count}</span><span className="coment"><FaRegCommentAlt size={18} color="#DAD9E2" /></span></p> */}
              </li>
            ))}
        </ul>
      </section>
    </div>
    </FeedLayout>
  )
}